<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-success">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('label.compare') }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-right">
              <div class="col-md-12 margin-bottom">
                <div class="form-inline">
                  <div class="input-group">
                    <datepicker
                      input-class="form-control"
                      @input="fetchFilterRecords"
                      v-model="filter.start"
                    />
                  </div>
                  <div class="input-group">
                    <datepicker
                      input-class="form-control"
                      @input="fetchFilterRecords"
                      v-model="filter.end"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{{ $t('label.types') }}</th>
                        <th>{{ $t('label.totalRecords') }}</th>
                        <th>{{ $t('label.amount') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="filterItems !== null">
                        <tr>
                          <td>{{ $t('menu.applicant') }}</td>
                          <td>{{ filterItems.borrows_pending.total }}</td>
                          <td>$ {{ filterItems.borrows_pending.amount }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('menu.borrower') }}</td>
                          <td>{{ filterItems.borrows_approved.total }}</td>
                          <td>$ {{ filterItems.borrows_approved.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.rejected') }}</td>
                          <td>{{ filterItems.borrows_rejected.total }}</td>
                          <td>$ {{ filterItems.borrows_rejected.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.invest') }}</td>
                          <td>{{ filterItems.invests.total }}</td>
                          <td>$ {{ filterItems.invests.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.referral') }}</td>
                          <td colspan="2">
                            {{ filterItems.referrals }}
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            colspan="2"
                            class="text-center"
                          >
                            No records
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div class="col-md-12 margin-bottom">
                <div class="form-inline">
                  <div class="input-group">
                    <datepicker
                      input-class="form-control"
                      @input="fetchSecondFilterRecords"
                      v-model="secondFilter.filter.start"
                    />
                  </div>
                  <div class="input-group">
                    <datepicker
                      input-class="form-control"
                      @input="fetchSecondFilterRecords"
                      v-model="secondFilter.filter.end"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{{ $t('label.types') }}</th>
                        <th>{{ $t('label.totalRecords') }}</th>
                        <th>{{ $t('label.amount') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="secondFilter.filterItems !== null">
                        <tr>
                          <td>{{ $t('menu.applicant') }}</td>
                          <td>{{ secondFilter.filterItems.borrows_pending.total }}</td>
                          <td>$ {{ secondFilter.filterItems.borrows_pending.amount }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('menu.borrower') }}</td>
                          <td>{{ secondFilter.filterItems.borrows_approved.total }}</td>
                          <td>$ {{ secondFilter.filterItems.borrows_approved.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.rejected') }}</td>
                          <td>{{ secondFilter.filterItems.borrows_rejected.total }}</td>
                          <td>$ {{ secondFilter.filterItems.borrows_rejected.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.invest') }}</td>
                          <td>{{ secondFilter.filterItems.invests.total }}</td>
                          <td>$ {{ secondFilter.filterItems.invests.amount }}</td>
                        </tr>

                        <tr>
                          <td>{{ $t('menu.referral') }}</td>
                          <td colspan="2">
                            {{ secondFilter.filterItems.referrals }}
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            colspan="2"
                            class="text-center"
                          >
                            No records
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('label.result') }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>{{ $t('label.types') }}</th>
                <th>{{ $t('label.totalRecordsDifferences') }}</th>
                <th>{{ $t('label.amountDifferences') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="secondFilter.filterItems !== null && filterItems !== null">
                <tr>
                  <td>{{ $t('menu.applicant') }}</td>
                  <td>
                    {{ secondFilter.filterItems.borrows_pending.total - filterItems.borrows_pending.total }}
                  </td>
                  <td>$ {{ parseFloat(secondFilter.filterItems.borrows_pending.amount) - parseFloat(filterItems.borrows_pending.amount) }}</td>
                </tr>
                <tr>
                  <td>{{ $t('menu.borrower') }}</td>
                  <td>
                    {{ secondFilter.filterItems.borrows_approved.total - filterItems.borrows_approved.total }}
                  </td>
                  <td>$ {{ parseFloat(secondFilter.filterItems.borrows_approved.amount) - parseFloat(filterItems.borrows_approved.amount) }}</td>
                </tr>

                <tr>
                  <td>{{ $t('menu.rejected') }}</td>
                  <td>
                    {{ secondFilter.filterItems.borrows_rejected.total - filterItems.borrows_rejected.total }}
                  </td>
                  <td>$ {{ parseFloat(secondFilter.filterItems.borrows_rejected.amount) - parseFloat(filterItems.borrows_rejected.amount) }}</td>
                </tr>

                <tr>
                  <td>{{ $t('menu.invest') }}</td>
                  <td>{{ secondFilter.filterItems.invests.total - filterItems.invests.total }}</td>
                  <td>$ {{ secondFilter.filterItems.invests.amount - filterItems.invests.amount }}</td>
                </tr>

                <tr>
                  <td>{{ $t('menu.referral') }}</td>
                  <td colspan="2">
                    {{ secondFilter.filterItems.referrals }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    colspan="2"
                    class="text-center"
                  >
                    No records
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import CashHeroBoxToolsAction from '../../components/CashHeroBoxToolsAction'

export default {
  name: 'CashHeroCompare',
  components: {
    CashHeroBoxToolsAction,
    Datepicker
  },
  data () {
    return {
      filter: {
        start: new Date(),
        end: new Date()
      },
      filterItems: null,
      secondFilter: {
        filter: {
          start: new Date(),
          end: new Date()
        },
        filterItems: null
      }
    }
  },
  methods: {
    fetchFilterRecords () {
      const start = this.$moment(this.filter.start).format('YYYY-MM-DD')
      const end = this.$moment(this.filter.end).format('YYYY-MM-DD')
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/report/dashboard/filter-records', {
        start: start,
        end: end
      }).then((response) => {
        if (response.data.code === 1) {
          this.filterItems = response.data.data
        }
      })
    },
    fetchSecondFilterRecords () {
      const start = this.$moment(this.secondFilter.filter.start).format('YYYY-MM-DD')
      const end = this.$moment(this.secondFilter.filter.end).format('YYYY-MM-DD')
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/report/dashboard/filter-records', {
        start: start,
        end: end
      }).then((response) => {
        if (response.data.code === 1) {
          this.secondFilter.filterItems = response.data.data
        }
      })
    }
  },
  mounted () {
    this.fetchFilterRecords()
    this.fetchSecondFilterRecords()
  }
}
</script>

<style scoped>
  .border-right {
    border-right: 1px solid #ddd;
  }
</style>
